var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1673_31173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5 0C22.9304 0 0.5 22.4304 0.5 50C0.5 77.5696 22.9304 100 50.5 100C78.0696 100 100.5 77.5696 100.5 50C100.5 22.4304 78.0696 0 50.5 0ZM13 50C13 41.9136 15.5986 34.4372 19.9679 28.3058L72.1942 80.5321C66.0628 84.9014 58.5864 87.5 50.5 87.5C29.8213 87.5 13 70.6787 13 50ZM81.0319 71.6942L28.8056 19.4679C34.937 15.0986 42.4134 12.5 50.4998 12.5C71.1785 12.5 87.9998 29.3213 87.9998 50C87.9998 58.0864 85.4012 65.5628 81.0319 71.6942Z",
    fill: "#E60101"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1673_31173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBlock);
export default __webpack_public_path__ + "static/media/redBlock.57537f83294f7bc182ffd2617a1c643f.svg";
export { ForwardRef as ReactComponent };